import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_API_URL from '../../../apis/index';
import { Tabs, Tab } from "@mui/material";
import styled from 'styled-components';
import ProductCard from "./ProductCard";
import CompProductSecBulkUploadsSec from './CompProductSecBulkUploadsSec';

export default function CompProductsSectionIngManf({ compId }) {
    const [products, setProducts] = useState([]);
    const [tab, setTab] = useState(0);
    const [sheetCount, setSheetCount] = useState(0);


    useEffect(() => {
        async function fetchSheetCount() {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(
                    `${BASE_API_URL}/api/admin/company/products/bulksheets/${compId}`,
                    {
                        params: { company_type: "Ingredient Manufacturer" },
                        headers: { Authorization: `Bearer ${authToken}` },
                    }
                );
                setSheetCount(res.data.result?.length || 0);
            } catch (err) {
                console.error(err);
            }
        }
        async function fetchProducts() {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(
                    `${BASE_API_URL}/api/admin/company/products/${compId}`,
                    {
                        params: { company_type: "Ingredient Manufacturer" },
                        headers: { Authorization: `Bearer ${authToken}` },
                    }
                );
                setProducts(res.data.result || []);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        }
        fetchProducts();
        fetchSheetCount();
    }, [compId]);


    return (
        <CompProductsSectionWrapper className="py-md-5 p-4 bg-light my-4 rounded-4">
            <div className="mb-4">
                <h4 className='fw-normal txt_color_primary'>
                    Products - Ingredient Manufacturer ({products.length})
                </h4>

                <Tabs value={tab} onChange={(e, val) => setTab(val)}>
                    <Tab label={`Ingredients (${products.length})`} />
                    <Tab label={`Bulk Uploaded Sheets (${sheetCount})`} />
                </Tabs>
            </div>

            {/* INGREDIENTS */}
            {tab === 0 && (
                <div className="d-flex flex-wrap gap-3">
                    {products.map((product) => {
                        const images = product.product_images
                            ? JSON.parse(product.product_images)
                            : [];
                        return (
                            <div className="ProductCard" key={product.id}>
                                <ProductCard product={product} images={images} />
                            </div>
                        );
                    })}
                </div>
            )}

            {/* BULK SHEETS */}
            {tab === 1 && (
                <CompProductSecBulkUploadsSec
                    compId={compId}
                    compType="Ingredient Manufacturer"
                    mode="sheets"   // ✅ NEW PROP
                />
            )}
        </CompProductsSectionWrapper>
    );
}

const CompProductsSectionWrapper = styled.div`
    .ProductCard{
        width: 380px;
        min-height: 450px;
    }
    .CardLink{
        border: 1px solid var(--secondary-color);
        padding: 10px 25px; 
        color: var(--secondary-color);
        font-size: 0.8rem;
        text-decoration: none;
        cursor: pointer;
        border-radius: 5px;
        transition: 0.5s;
        &:hover{
          background: var(--secondary-color);
          color: white;
        }
    }
`;

